<template>
  <div class="found_container" id="found_container" ref="found_container">
    <div>
      <div class="circletab" ref="circletab">
        <div class="found_top">
          <div class="navbar">
            <navbar :titlename="titlename"></navbar>
          </div>
          <ul class="circleul">
            <li :class="liindex==0 ? 'active' : '' " data-index="0" @click="changeliindex">
              <span>鼓掌</span>
            </li>
            <li :class="liindex==1 ? 'active' : '' " data-index="1" @click="changeliindex">
              <span>商品</span>
            </li>
          </ul>
        </div>
        <div class="findbigbox" v-if="liindex==0">
          <van-list v-if="dynamiclistdata.length != 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div v-for="(item,index) in dynamiclistdata" :key="index">
              <dynamiclist :dynamiclistdata="item" :allnamiclistdata="dynamiclistdata" :alldynamiccnum="dynamiccontent.totalCount" :dylistindex="index" :isown="dynamiccontent.is_own" :isdytemple="isdytemple" :collectnojb="collectnojb"></dynamiclist>
            </div>
          </van-list>
          <div v-else class="nofollowbox">
            <div class="nofollowpic">
              <img src="../../assets/images/circle_icon_wu.png" onclick="return false" />
            </div>
            <div class="nosearchtext">暂无收藏</div>
          </div>
        </div>
        <div class="findbigbox" v-if="liindex==1">
          <div class="nofollowbox">
            <div class="nofollowpic">
              <img src="../../assets/images/circle_icon_wu.png" onclick="return false" />
            </div>
            <div class="nosearchtext">暂无商品信息</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getcollection } from "../../api/api";

import navbar from "../public/navbar.vue";
import dynamiclist from "../public/dynamiclist";

import Vue from "vue";
import { Search, Toast, List } from "vant";

Vue.use(List);
Vue.use(Search);
Vue.use(Toast);

export default {
  components: { navbar, dynamiclist },
  data () {
    return {
      titlename: "我的收藏",
      liindex: 0,
      loading: false,
      finished: false,
      dynamiclistdata: [],
      dynamiccontent: [],
      isdytemple: [],
      page: 0,
      pageCount: 0,
      isdytemple: false,//表示是动态的模板
      collectnojb: true,//表示是收藏模板


    };
  },
  created () {
    Toast.loading({
      mask: true,
      message: '加载中...'
    });
    document.title = this.titlename;
    let json = {
      page: 0
    }

    getcollection(json).then(res => {
      Toast.clear();
      if (res.data.code == 200) {

        this.dynamiccontent = res.data.data;
        this.dynamiclistdata = res.data.data.list;
        this.loading = false;
        this.pageCount = res.data.data.pageCount;
        this.finished = false;
      } else {
        Toast.fail('数据异常，请刷新！');

      }
    }).catch(err => {
      Toast.clear();
    });
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'dynamic' || from.name == 'dynamicdetails') { // 这个name是下一级页面的路由name        
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next()
  },
  mounted () { },
  methods: {
    onLoad () {
      // 异步更新数据

      setTimeout(() => {
        var page = this.page;
        let that = this;
        let pageCount = this.pageCount;
        page++;
        if (page > pageCount) {
          that.finished = true;
          that.loading = false;
          return;
        }
        that.page = page;

        let json = {
          page: page
        }

        getcollection(json).then(res => {
          if (res.data.code == 200) {

            that.loading = false;
            let dynamiclistarr = that.dynamiclistdata;
            let newarr = res.data.data.list;
            newarr.forEach(function (e) {
              dynamiclistarr.push(e);
            });
            that.dynamiclistarr = dynamiclistarr
          }
        });
      }, 500);
    },
    changeliindex: function (e) {
      this.liindex = e.currentTarget.dataset.index;
      /*   this.page = 0; */
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
      /*     this.loading = false;
      this.finished = false;
      this.getnewlist(); */
    }
  }
};
</script>

<style>
.van-search__content {
  background-color: #f8f8f8;
}
.van-nav-bar {
  border-bottom: 1px solid #fff !important;
}
.van-hairline--bottom::after {
  border-bottom-width: 0px !important;
}
</style>
<style scoped>
.found_top {
  width: 100%;
  position: fixed;
  z-index: 90;
}
.found_container .circletab .circleul {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #efefef;
  padding: 0 1.2rem;
  padding-top: 50px;
  background: #fff;
}
.found_container .circletab .circleul li {
  font-size: 0.81rem;
  text-align: center;
  color: #666666;
  flex: 0 0 33.333%;
}
.found_container .circletab .circleul li span {
  padding: 0.5rem 0;
  display: inline-block;
}
.found_container .circletab .circleul li.active {
  color: #ffbd0a;
}
.found_container .circletab .circleul li.active span {
  border-bottom: 3px solid #ffbd0a;
}
.findbigbox {
  /* margin-top: 79px; */
  padding-top: 92px;
}
.nofollowbox {
  padding-top: 2.7027027027027026rem;
  text-align: center;
}
.nofollowbox .nofollowpic {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
  margin: 0 auto;
}
.nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nofollowbox .nosearchtext {
  text-align: center;
  padding-top: 1.3513513513513513rem;
  font-size: 0.7567567567567568rem;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/collection.vue